import { Svg, Path } from 'react-native-svg';

const CancelKey = () => {
  return (
    <Svg width="30" height="30" viewBox="0 0 48 36" fill="none">
      <Path
        d="M44 0H14C12.62 0 11.54 0.7 10.82 1.76L0 18L10.82 34.22C11.54 35.28 12.62 36 14 36H44C46.2 36 48 34.2 48 32V4C48 1.8 46.2 0 44 0ZM44 32H14.14L4.8 18L14.12 4H44V32ZM20.82 28L28 20.82L35.18 28L38 25.18L30.82 18L38 10.82L35.18 8L28 15.18L20.82 8L18 10.82L25.18 18L18 25.18L20.82 28Z"
        fill="#1E1E1E"
      />
    </Svg>
  );
};

export default CancelKey
